module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.float) ? _c('span', {
    staticClass: "float-label"
  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.disabled,
      "type": _vm.type,
      "title": _vm.error,
      "pattern": _vm.pattern,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        _vm.navigation('up')
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.navigation('down')
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
        _vm.select(_vm.value, _vm.searched[_vm.navigate].key || _vm.searched[_vm.navigate]['.key'], _vm.searched[_vm.navigate].value, _vm.searched[_vm.navigate].dealer || false, _vm.searched[_vm.navigate].transporter || false)
      }],
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.select(_vm.value, _vm.searched[_vm.navigate].key || _vm.searched[_vm.navigate]['.key'], _vm.searched[_vm.navigate].value, _vm.searched[_vm.navigate].dealer || false, _vm.searched[_vm.navigate].transporter || false)
      },
      "blur": function($event) {
        _vm.leave()
      },
      "focus": function($event) {
        _vm.focus()
      },
      "input": function($event) {
        _vm.searchAndEmit($event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.dropdown) ? _c('div', {
    ref: "dropdown",
    staticClass: "card dropdown-list",
    on: {
      "mouseover": function($event) {
        _vm.hovering = true
      },
      "mouseleave": function($event) {
        _vm.hovering = false
      }
    }
  }, _vm._l((_vm.searched), function(item, index) {
    return _c('a', {
      staticClass: "dropdown-item  px-3 py-1",
      class: {
        'navigate': _vm.navigate === index
      },
      attrs: {
        "data-key": item.key || item['.key'],
        "data-value": item.value
      },
      on: {
        "mouseenter": function($event) {
          _vm.navigate = index
        },
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.select(_vm.value, $event.target.getAttribute('data-key'), $event.target.getAttribute('data-value'), item.dealer || false, item.transporter || false)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.value || item.name) + "\n        ")])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8f26c96","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/regularDatalist.vue
// module id = 852
// module chunks = 1